const SmallPickup = () => {
	return (
		<svg
			width="16"
			height="17"
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				width="16"
				height="16"
				rx="2.66667"
				transform="matrix(1 0 0 -1 0 16.7842)"
				fill="#FFB352"
			/>
			<path
				d="M7.31152 3.62878C7.67743 3.21714 8.32058 3.21721 8.68652 3.62878L12.5068 7.92664C12.866 8.33068 12.5796 8.96942 12.0391 8.9696H10.9326C10.4688 8.9696 10.0928 9.34563 10.0928 9.80945V11.5692C10.0926 12.077 9.68062 12.4889 9.17285 12.4891H6.82617C6.31825 12.4891 5.90644 12.0771 5.90625 11.5692V9.80945C5.90625 9.34563 5.53022 8.9696 5.06641 8.9696H3.95996C3.41941 8.9696 3.13239 8.33076 3.49121 7.92664L7.31152 3.62878Z"
				fill="#FFB352"
				stroke="#454545"
				strokeWidth="0.666667"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export default SmallPickup;
